import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, useState, useRef } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import IndexBloc from "./Blocs/IndexBloc";
import apiResponse from "../../../../services/apiResponse";
import Select from "react-select";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Input,
} from "reactstrap";

import TableActiveComponent from "./Components/TablePrimaryComponent";
import TableMonitoring from "./Components/TableMonitoringComponent";
import { SelectionState } from "draft-js";

const IndexView = (props) => {
  let indexBloc = new IndexBloc();
  const [activeTab, setactiveTab] = useState(
    sessionStorage.getItem("indexRetiredActiveTab")
      ? sessionStorage.getItem("indexRetiredActiveTab")
      : "2"
  );
  const activeRef = useRef();
  const inactiveRef = useRef();
  const [fileUrl, setFileUrl] = useState("");

  const reloadInactiveRef = () => activeRef.current.setTokenAPI();
  const reloadMontoring = () => activeRef.current.setTokenAPI();

  function toggle(tab) {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  }

  function handleButtonSearch() {}

  function handleButtonReset() {}

  function onChangeTahunSelected(element) {
    if (element) {
      var selected_element = element.value;
    }
  }

  function download() {
    indexBloc.exportExcelChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response);
            //setFileUrl(response.file_url)
            window.location.href = response.file_url;
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    indexBloc.fetchExportExcel();
  }

  return (
    <Fragment>
      <Container fluid>
        <Row>
          <Col className="col-12">
            <Card>
              <CardBody>
                <CardTitle>Daftar Ususlan Pemberhentian</CardTitle>
                <CardSubtitle className="mb-3">
                  Kelola Daftar Usulan Pemberhentian Pegawai
                </CardSubtitle>
                <hr />
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === "2",
                      })}
                      onClick={() => {
                        toggle("2");
                        sessionStorage.setItem("indexRetiredActiveTab", "2");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-envelope"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        <i class="uil-chat-bubble-user"></i>&nbsp;Data Usulan
                        Pemberhentian
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === "1",
                      })}
                      onClick={() => {
                        toggle("1");
                        sessionStorage.setItem("indexRetiredActiveTab", "1");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="fas fa-home"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        <i class="uil-user-plus"></i>&nbsp;Permohonan Usulan
                        Pemberhentian
                      </span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} className="p-3 text-muted">
                  <TabPane tabId="1">
                    <br />
                    <div className="float-end">
                      {accessRole("create") ? (
                        <Link to="?submission">
                          <Button color="primary">
                            <i class="uil-plus-circle"></i>&nbsp;Tambah Periode
                            Usulan
                          </Button>
                        </Link>
                      ) : null}
                      &nbsp;
                    </div>
                    <div
                      className="clearfix"
                      style={{ padding: ".5rem" }}
                    ></div>
                    <br />
                    <TableActiveComponent
                      ref={activeRef}
                      handleInactiveSuccess={reloadInactiveRef}
                    />
                  </TabPane>
                  <TabPane tabId="2">
                    <TableMonitoring
                      ref={inactiveRef}
                      handleActiveSuccess={reloadMontoring}
                    />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default IndexView;
